import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "product";
const pathData = "M476 131q11 7 11 18 0 3-1 5v204q0 15-13 23L270 508q-7 4-15 4-9 0-13-4L38 381q-6-4-9.5-11T25 358V154q0-15 13-23l102-64q8-3 15-3t13 3l204 128q5 2 8.5 8.5T384 215v89q0 26-25 26-11 0-18.5-7t-7.5-19v-74L155 118l-76 49v176l178 112 178-112V167L244 47q-12-8-12-21 0-5 4-15 9-11 23-11 8 0 13 4zM222 327q12 7 12 21 0 8-4 15-8 11-23 11-7 0-13-3l-51-31q-12-8-12-20 0-8 5-16 9-11 22-11 8 0 13 4z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/product";
export { pathData, ltr, accData };